import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import PropTypes from 'prop-types'
import * as requestTypeCode from '../../scripts/RequestTypeCodeString'
import RequestDetailLeaveDisplay from './RequestDetailLeaveDisplay'
import RequestDetailVacationDisplay from './RequestDetailVacationDisplay'

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RequestDetail(props) {
    const classes = useStyles();

    const { onClose, open, data } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {i18next.t("request:tabPanelDetail.detailRequest")}
                    </Typography>
                </Toolbar>
            </AppBar>
            {data.request.requestType === requestTypeCode.Type_Leave && <RequestDetailLeaveDisplay data={data} dataRequest={data.request} />}
            {data.request.requestType === requestTypeCode.Type_Vacation && <RequestDetailVacationDisplay data={data} dataRequest={data.request} />}
        </Dialog>
    )
}

RequestDetail.propTypes = {
    data: PropTypes.object.isRequired
}